<template>
  <zh-table-page
    ref="tableRef"
    v-bind="{
      title: '用户管理',
      search,
      api,
      commands: [],
      handleTree,
      afterGetDetail,
      beforeSave,
      ...table,
      ...tree,
      ...dialog
    }"
    @action="handleAction"
  >
    <template #header-btn>
      <el-upload
        style="margin:0 10px"
        :show-file-list="false"
        :limit="1"
        accept=".xls,.xlsx"
        :http-request="handleImportUpload"
      >
        <el-button type="primary">导入</el-button>
      </el-upload>
      <el-button @click="downloadImportTemplate">下载导入模板</el-button>
    </template>
  </zh-table-page>
  <el-dialog v-model="dialogVisible" title="分配角色" width="700">
    <el-descriptions title="">
      <el-descriptions-item label="姓名:">{{
        curScope.nikeName
      }}</el-descriptions-item>
      <el-descriptions-item label="手机号:">{{
        curScope.phone
      }}</el-descriptions-item>
    </el-descriptions>
    <el-transfer
      v-model="transferValue"
      :titles="['角色列表', '拥有角色']"
      :data="transferData"
      :right-default-checked="rightDefaultChecked"
    />
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveAllocation"> 确认 </el-button>
      </span>
    </template>
  </el-dialog>
  <el-dialog v-model="dialogData" title="数据权限" width="700">
    <el-checkbox v-model="menuExpand">展开/折叠</el-checkbox>
    <el-checkbox v-model="menuNodeAll">全选/全不选</el-checkbox>
    <div style="width: 100%">
      <el-tree
        ref="menuRef"
        :data="treeData"
        show-checkbox
        @check="handleNodeClick"
        node-key="id"
        v-if="dialogData"
        :default-checked-keys="defaultCheckedKeys"
      />
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogData = false">取消</el-button>
        <el-button type="primary" @click="saveData"> 确认 </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  getCurrentInstance,
  onMounted,
  watch
} from "vue";
import { useRouter } from "vue-router";
import { ElMessageBox } from "element-plus";
import { replaceObjectKeys } from "@pansy/utils";
import CryptoJS from "@/utils/crypto.js";
export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const tableRef = ref();
    const menuRef = ref();
    const state = reactive({
      search: [
        {
          label: "姓名",
          placeholder: "姓名",
          value: "nikeName"
        },
        {
          label: "手机号码",
          placeholder: "手机号码",
          value: "phone"
        },

        {
          component: "zh-select",
          label: "状态",
          placeholder: "状态",
          value: "state",
          url: "postDictDataList",
          params: {
            dictType: "center_use_state"
          },
          field: {
            dictValue: "value",
            dictLabel: "label"
          }
        }
      ],
      api: {
        list: "postUserPage",
        delete: "deleteUserDeleteBatch",
        add: "postUserSave",
        edit: "postUserUpdate",
        detail: "getUser",
        tree: "getOrganizationalGetOrganizationalTreeSelect"
      },
      tree: {
        treeField: {
          organizationName: "label"
        }
      },
      table: {
        columns: [
          { label: "姓名", prop: "nikeName", width: "100", fixed: "left" },
          { label: "手机号码", prop: "phone", width: "110" },
          {
            label: "部门名称",
            prop: "orgName",
            width: "200",
            showOverflowTooltip: true
          },
          { label: "岗位名称", prop: "postName", width: "100" },
          {
            label: "角色",
            prop: "roleName",
            width: "200",
            showOverflowTooltip: true
          },
          {
            label: "状态",
            prop: "state",
            width: "150",
            scopeComponent: "common-switch"
          },
          {
            label: "在职状态",
            prop: "workState",
            width: "100",
            scopeFun: (scope) => {
              if (scope.row.workState) {
                return scope.row.workState.desc;
              }
            }
          },
          { label: "邮箱", prop: "email", width: "100" },
          { label: "创建时间", prop: "createTime", width: "180" }
        ],
        operations: [
          {
            label: "重置密码",
            disabledFun: (row) => {
              return row.state.value == 1 || row.userCode == 1;
            }
          },
          {
            label: "分配角色",
            disabledFun: (row) => {
              return row.state.value == 1 || row.userCode == 1;
            }
          },
          {
            label: "数据权限",
            disabledFun: (row) => {
              return row.state.value == 1 || row.userCode == 1;
            }
          },
          {
            label: "编辑",
            disabledFun: (row) => {
              return row.userCode == 1;
            }
          },
          {
            label: "删除",
            type: "danger",
            disabledFun: (row) => {
              return row.userCode == 1;
            }
          }
        ],
        rowKey: "userCode",
        operationsWidth: "330"
      },
      dialog: {
        dialogForm: [
          {
            label: "姓名",
            placeholder: "请输入姓名",
            value: "nikeName"
          },
          {
            label: "手机号码",
            placeholder: "手机号码默认为登录账号",
            value: "phone"
          },
          {
            label: "账号密码",
            placeholder: "请输入账号密码",
            value: "passWord",
            type: "password"
          },
          {
            component: "zh-tree-select",
            label: "归属部门",
            placeholder: "请选择归属部门",
            value: "orgCode",
            url: "getOrganizationalGetOrganizationalTreeSelect",
            field: {
              organizationName: "label",
              organizationCode: "value"
            },
            params: {
              state: 0
            }
          },
          {
            component: "zh-select",
            label: "岗位名称",
            placeholder: "请选择岗位",
            value: "postCode",
            url: "postPostList",
            field: {
              postCode: "value",
              postName: "label"
            }
          },
          {
            component: "zh-select",
            label: "角色名称",
            placeholder: "请选择角色",
            value: "roleCode",
            url: "postRoleList",
            field: {
              roleCode: "value",
              roleName: "label"
            },
            multiple: true
          },
          {
            label: "邮箱",
            placeholder: "请输入邮箱",
            value: "email"
          },
          {
            component: "zh-select",
            label: "是否启用",
            placeholder: "请选择是否启用",
            value: "state",
            url: "postDictDataList",
            params: {
              dictType: "center_use_state"
            },
            field: {
              dictValue: "value",
              dictLabel: "label"
            },
            defaultValue: 0
          },
          {
            component: "zh-select",
            label: "在职状态",
            placeholder: "请选择在职状态",
            value: "workState",
            url: "postDictDataList",
            params: {
              dictType: "center_use_workState"
            },
            field: {
              dictValue: "value",
              dictLabel: "label"
            }
          },
          {
            label: "备注信息",
            placeholder: "请输入内容",
            value: "remark",
            type: "textarea"
          }
          // {
          //   label: "账号名称",
          //   placeholder: "请输入账号名称",
          //   value: "userName",
          //   showCondition: (form) => {
          //     return !form.userId;
          //   },
          // },
          // {
          //   label: "确认密码",
          //   placeholder: "请输入确认密码",
          //   value: "passWord",
          // },
          // {
          //   component: "zh-select",
          //   label: "用户性别",
          //   placeholder: "请选择用户性别",
          //   value: "sex",
          //   url: "getSystemDictDataType",
          //   params: {
          //     id: "sys_user_sex",
          //   },
          //   field: {
          //     dictValue: "value",
          //     dictLabel: "label",
          //   },
          // },
        ],
        dialogRules: {
          userName: [
            { required: true, message: "姓名不能为空", trigger: "blur" }
          ],
          nikeName: [
            { required: true, message: "姓名不能为空", trigger: "blur" }
          ],
          phone: [
            {
              required: true,
              pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
              message: "请输入正确的手机号码",
              trigger: "blur"
            }
          ],
          orgCode: [
            { required: true, message: "归属部门不能为空", trigger: "blur" }
          ],
          // passWord: [
          //   { required: true, message: "用户密码不能为空", trigger: "blur" },
          //   {
          //     min: 5,
          //     max: 20,
          //     message: "用户密码长度必须介于 5 和 20 之间",
          //     trigger: "blur",
          //   },
          // ],
          email: [
            {
              type: "email",
              message: "请输入正确的邮箱地址",
              trigger: ["blur", "change"]
            }
          ]
        }
      },
      dialogVisible: false,
      dialogData: false,
      transferData: [],
      transferValue: [],
      rightDefaultChecked: [],
      curScope: null,
      treeData: [],
      checkedNodes: [],
      defaultCheckedKeys: [],
      menuExpand: false,
      menuNodeAll: false
    });
    onMounted(() => {
      getRoleList();
      getMenu();
    });
    //获取角色列表
    const getRoleList = () => {
      proxy.$api.postRoleList({}).then((res) => {
        if (res.data) {
          state.transferData = replaceObjectKeys(
            res.data,
            {
              roleCode: "key",
              roleName: "label"
            },
            {
              simplify: false
            }
          );
        }
      });
    };
    /*处理 点击tree时查询列表的传参 */
    const handleTree = (node) => {
      return {
        orgCode: node.organizationCode
      };
    };
    /*点击列表中行组件触发的方法*/
    const handleAction = (item, type) => {
      if (type === "scope") {
        if (item.userCode == 1) {
          tableRef.value.handleSearch();
          return;
        }
        proxy
          .$confirm("是否修改用户状态?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            proxy.$api.getUser(item.userCode).then((res) => {
              proxy.$api
                .postUserUpdate({
                  userCode: res.data.userCode,
                  state: res.data.state.value == 1 ? 0 : 1
                })
                .then((res) => {
                  tableRef.value.handleSearch();
                  proxy.$message.success("操作成功");
                });
            });
          })
          .catch(() => {
            tableRef.value.handleSearch();
          });
      } else if (type === "重置密码") {
        handleReset(item);
      } else if (type === "分配角色") {
        handleAllocation(item);
      } else if (type === "数据权限") {
        handleData(item);
      }
    };
    // 下载导入模板
    const downloadImportTemplate = () => {
      proxy.$api.getUserDownloadLoginTemplate().then((res) => {
        const fileName = res.fileName || "用户导入模板.xlsx";
        const link = document.createElement("a");
        link.download = fileName;
        document.body.appendChild(link);
        const isSecureContext =
          window.isSecureContext ||
          window.location.protocol === "https:" ||
          window.location.hostname === "localhost" ||
          window.location.hostname === "127.0.0.1";

        if (isSecureContext) {
          const url = window.URL.createObjectURL(res.blob);
          link.href = url;
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          return;
        }

        // http 场景下避免 blob: URL 触发浏览器安全提示
        const reader = new FileReader();
        reader.onload = (e) => {
          link.href = e.target.result;
          link.click();
          document.body.removeChild(link);
        };
        reader.onerror = () => {
          document.body.removeChild(link);
          proxy.$message.error("下载失败，请稍后重试");
        };
        reader.readAsDataURL(res.blob);
      });
    };
    // 导入用户模板
    const handleImportUpload = (options) => {
      const formData = new FormData();
      formData.append("file", options.file);
      proxy.$api
        .postUserImportByTemplate(formData)
        .then((res) => {
          options.onSuccess(res);
          proxy.$message.success(res?.message || "导入成功");
          tableRef.value.handleSearch();
        })
        .catch((err) => {
          options.onError(err);
        });
    };
    //处理详情数据
    const afterGetDetail = (data) => {
      console.log({
        ...data,
        state: data.state?.value ?? 1,
        workState: data.workState?.value ?? 1,
        roleCode: data.roleCode ? data.roleCode.split(",") : []
      });
      return {
        ...data,
        state: data.state?.value ?? 1,
        workState: data.workState?.value ?? 1,
        roleCode: data.roleCode ? data.roleCode.split(",") : []
      };
    };
    //点击重置密码
    const handleReset = ({ row }) => {
      ElMessageBox.confirm("是否重置当前用户的密码为默认密码?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          proxy.$api
            .postUserResetPassword({ userCode: row.userCode })
            .then((res) => {
              if (res.data.value) {
                proxy.$message.success("操作成功");
              } else {
                proxy.$message.error("操作失败");
              }
            });
        })
        .catch(() => {});
    };
    //点击分配角色
    const handleAllocation = (scope) => {
      state.transferValue = [];
      state.rightDefaultChecked = [];
      if (scope.row.roleCode) {
        state.transferValue = scope.row.roleCode.split(",");
      }
      state.curScope = scope.row;
      state.dialogVisible = true;
    };
    //保存分配角色
    const saveAllocation = () => {
      if (state.transferValue.length === 0) {
        proxy.$message.warning("请选择角色");
      } else {
        let data = state.curScope;
        if (data.userCode) {
          delete data.passWord;
        }
        proxy.$api
          .postUserUpdate({
            ...state.curScope,
            roleCode: state.transferValue.join(",")
          })
          .then((res) => {
            if (res.data) {
              tableRef.value.handleSearch();
              proxy.$message.success("操作成功");
              state.dialogVisible = false;
            }
          });
      }
    };
    //处理详情数据
    const beforeSave = (data) => {
      return {
        ...data,
        passWord: data.passWord
          ? CryptoJS.encryptWithHMAC(data.passWord)
          : null,
        roleCode:
          data.roleCode && data.roleCode.length > 0
            ? data.roleCode.join(",")
            : data.roleCode
      };
    };

    const getMenu = () => {
      proxy.$api.getOrganizationalGetOrganizationalTreeSelect().then((res) => {
        if (res.data) {
          state.treeData = replaceObjectKeys(
            res.data,
            {
              organizationName: "label",
              organizationCode: "id"
            },
            {
              simplify: false
            }
          );
        }
      });
    };
    //点击数据权限
    const handleData = (scope) => {
      state.curScope = scope.row;
      state.checkedNodes = scope.row.dataPermission
        ? scope.row.dataPermission.split(",")
        : [];
      state.defaultCheckedKeys = scope.row.dataPermission
        ? scope.row.dataPermission.split(",")
        : [];
      state.dialogData = true;
    };
    const handleNodeClick = (data, node) => {
      state.checkedNodes = node.checkedKeys;
    };
    //全部展开/折叠
    watch(
      () => state.menuExpand,
      (n) => {
        unFoldAll(state.treeData, n);
      }
    );
    const unFoldAll = (data, n) => {
      data.forEach((el) => {
        menuRef.value.store.nodesMap[el.id].expanded = n;
        el.children && el.children.length > 0 ? unFoldAll(el.children) : ""; //
      });
    };

    //全选/全不选
    watch(
      () => state.menuNodeAll,
      (n) => {
        state.checkedNodes = [];
        menuRef.value.setCheckedNodes(n ? state.treeData : []);
        nodeAll(n ? state.treeData : []);
      }
    );
    const nodeAll = (data) => {
      data.forEach((el) => {
        state.checkedNodes.push(el.id);
        el.children && el.children.length > 0 ? nodeAll(el.children) : ""; //
      });
    };
    //保存数据权限
    const saveData = () => {
      if (state.checkedNodes.length === 0) {
        proxy.$message.warning("请选择权限");
        return;
      }
      proxy.$api
        .postAuthDataPermissionSave({
          organizationCodes: state.checkedNodes.join(","),
          userCode: state.curScope.userCode
        })
        .then((res) => {
          tableRef.value.handleSearch();
          proxy.$message.success("操作成功");
          state.dialogData = false;
        });
    };

    return {
      ...toRefs(state),
      tableRef,
      menuRef,
      handleAction,
      downloadImportTemplate,
      handleImportUpload,
      handleTree,
      afterGetDetail,
      saveAllocation,
      beforeSave,
      handleNodeClick,
      saveData
    };
  }
});
</script>
<style lang="less">
.layout-header-btn {
  display: flex !important;
  align-items: center !important;
  flex-wrap: nowrap !important;
  white-space: nowrap !important;
}

.layout-header-btn > * {
  flex-shrink: 0 !important;
}

.layout-header-btn .el-upload {
  display: inline-flex !important;
  width: auto !important;
}
</style>
